export default __webpack_public_path__ + "navigation-overview-setup-ib-segue-1200-c32dcf2a84ebc3dd861ab307accfd8cd.webp";